export const SET_CONTRACTS = 'SET_CONTRACTS';
export const SET_ACTIVE_CONTRACT = 'SET_ACTIVE_CONTRACT';

// initial state
const state = {
    list: {},
    active: {},
    signed: {}
}

// getters
const getters = {
    contracts: state => state.list,
    contract: state => state.active
}

// actions
const actions = {
    getContract: ({commit, state}, payload) => {
        axios.get(laroute.route('api.contracts.show', {contract: payload.id}))
        .then((response) => {
            commit(SET_ACTIVE_CONTRACT, {
                active: response.data.data
            });
        })
    },

    setActiveContract: ({commit, state}, payload) => {
        commit(SET_ACTIVE_CONTRACT, {
            active: payload
        })
    }
}

// mutations
const mutations = {
    SET_CONTRACTS: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.organizations);
    },

    SET_ACTIVE_CONTRACT: (state, payload) => {
        state.active = Object.assign({}, state.active, payload.active);
    },

    SET_SIGNED_CONTRACT: (state, payload) => {
        state.signed = Object.assign({}, state.signed, payload.signed);
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
